import { Middleware, Store } from "redux"
import CallTypes from "store/call/call.types"

const appChannel = new BroadcastChannel('smartagent-service-worker-out');

import { acceptCall, rejectCall } from "store/call/call.actions";
import RootState from "store/state";
import AppTypes from "store/app/app.types";
import AnyAction from "store/anyActions";
import ChatTypes from "store/chat/chat.types";
import TaskTypes from "store/tasks/tasks.types";
import { acceptChat, declineChat } from "store/chat/chat.actions";
import { acceptTask, declineTask } from "store/tasks/tasks.actions";

const findIncomingChat = (store: Store<RootState>) => {
    return store.getState().chat.connections.find(c => c.status === 'connecting')?.id!
}

const findIncomingTask = (store: Store<RootState>) => {
    return store.getState().tasks.connections.find(t => t.status === "connecting")?.id!
}

const listenForMessages = async (store: Store<RootState>) => {
    await navigator.serviceWorker.ready;

    appChannel.addEventListener('message', event => {

        switch (event.data.type) {
            case "acceptCall": return store.dispatch(acceptCall());
            case "rejectCall": return store.dispatch(rejectCall());
            case "acceptChat": return store.dispatch(acceptChat(findIncomingChat(store)))
            case "rejectChat": return store.dispatch(declineChat(findIncomingChat(store)))
            case "acceptTask": return store.dispatch(acceptTask(findIncomingTask(store)));
            case "rejectTask": return store.dispatch(declineTask(findIncomingTask(store)))
            default: return;
        }
    })

}

const postMessageToSw = (type: string, data: any = {}) => {
    navigator.serviceWorker.ready.then((registration) => {
        registration.active?.postMessage({
            type,
            data
        })
    })
}

const browserNotificationMiddleware: Middleware<{}, RootState> = store => next => {

    window.addEventListener('focus', () => {
        postMessageToSw('windowFocus', {})
    })

    return (action: AnyAction) => {

        // init listener
        if (action.type === AppTypes.INIT_APP_SUCCESS) {
            listenForMessages(store as Store);
        }

        // Missed contact notifications
        switch (action.type) {
            case CallTypes.MISSED_CALL:
                postMessageToSw('missedContact', {
                    contactType: "call"
                })
                break;

            case ChatTypes.CHAT_MISSED:
                postMessageToSw('missedContact', {
                    contactType: "chat"
                })
                break;

            case TaskTypes.TASK_MISSED:
                postMessageToSw('missedContact', {
                    contactType: "email"
                })
                break;
        }
        

        // incoming contact notifications
        switch (action.type) {
            case CallTypes.INCOMING_CALL:
                postMessageToSw('incomingCall', {
                    number: action.payload.number,
                    autoAcceptOn: !!store.getState().user.softphoneAutoAccept
                });
                break;
            case ChatTypes.ADD_CHAT_CONNECTION:
                postMessageToSw('incomingChat', {
                    customerName: action.payload.customerName
                });
                break;
            case TaskTypes.ADD_TASK_CONNECTION:
                postMessageToSw('incomingTask', {
                    customerName: action.payload.name
                });
                break;

            case CallTypes.MISSED_CALL:
            case CallTypes.ACCEPT_CALL:
            case CallTypes.REJECT_CALL:
            case CallTypes.CALL_STARTED:
            case ChatTypes.CHAT_MISSED:
            case ChatTypes.ACCEPT_CHAT:
            case ChatTypes.DECLINE_CHAT:
            case TaskTypes.TASK_MISSED:
            case TaskTypes.ACCEPT_TASK:
            case TaskTypes.DECLINE_TASK:
                postMessageToSw('contactOver');
                break;

            default:
                break
        }

        return next(action);

    }
}

export default browserNotificationMiddleware